<template>
  <div>
    <app-cells>
      <h2 class="title">{{ groupDetail.route.accommodation_type?.code === 'huts' ? 'Allocated huts' : 'Allocated tents' }}</h2>
    </app-cells>
    <v-client-table
      :data="table.items"
      :columns="table.columns"
      :options="table.options"
      class="table-default"
    >
      <template #h__clients>
        <div class="table-default__left">Clients</div>
      </template>
      <template #count="{ row }">{{ row.index }}</template>
      <template #clients="{ row }">
        <app-cells :indent="false">
          <div
              v-for="(client, index) of row.clients"
              :key="client.id"
              class="table-default__left table-default__left--photo"
          >
            <span
                :class="`fflag ff-md fflag-${client.client.citizenship ? client.client.citizenship.code : 'empty'}`"
                v-tooltip="{ content: client.client.citizenship ? client.client.citizenship.name : 'Not provided', placement: 'top-start', offset: 10 }"
            ></span>
            <img v-if="client.client.gender?.code === 'male'" src="@/assets/img/male-icon.svg" alt="">
            <img v-if="client.client.gender?.code === 'female'" src="@/assets/img/female-icon.svg" alt="">
            <img v-if="!client.client.gender" src="@/assets/img/gender-plug-icon.svg" alt="">
            <router-link
              v-if="is_general_manager || is_sales_manager || is_sales_supervisor || is_operations_manager || is_operations_supervisor"
              :to="{ name: 'clients-detail', params: { id: client.client.id } }"
              class="table-default__link-border"
            >
              {{ client.client.full_name }}
            </router-link>
            <span v-else>{{ client.client.full_name }}</span>
            <span v-if="client.age">({{ client.age }} y.o.)</span>
            {{ index !== row.clients.length - 1 ? '|' : '' }}
          </div>
          <span
              v-if="row.clients.length === 1 && !row.additional_service"
              class="status-tag"
              :style="{ 'backgroundColor': '#f0c427' }"
          >
            Need a roommate
          </span>
        </app-cells>
      </template>
      <template #additional_service="{ row }">
        <span
            v-if="row.additional_service"
            class="status-tag"
            :style="{ 'backgroundColor': row.additional_service.code === 'walkin_tent' ? '#f0c427' : '#77b017' }"
        >
            {{ row.additional_service.name }}
          </span>
        <template v-else>-</template>
      </template>
      <template #created_by="{ row }">
        <div class="table-default__controls">
          <div class="table-default__photo">
            <img
              :src="getUserAvatar(row.created_by.crop.crop_url)" alt=""
              v-tooltip="{ content: `${row.created_by.full_name}<br>${dateTimeFormat(row.created_at)}`, placement: 'top-start', offset: 10, html: true }"
            >
          </div>
        </div>
      </template>
      <template #updated_by="{ row }">
        <div class="table-default__controls">
          <div class="table-default__photo">
            <img
              :src="getUserAvatar(row.updated_by.crop.crop_url)" alt=""
              v-tooltip="{ content: tooltipContent(row), placement: 'top-start', offset: 10, html: true }"
            >
          </div>
        </div>
      </template>
      <template #controls="{ row }">
        <div class="table-default__controls">
          <button @click="onShowEventModal(row)" type="button">
            <img src="@/assets/img/edit-table-icon.svg" alt="Edit">
          </button>
          <button @click="onShowDeleteModal(row.id)" type="button">
            <img src="@/assets/img/delete-table-icon.svg" alt="Delete">
          </button>
        </div>
      </template>
    </v-client-table>
    <template v-if="table_clients.items.length">
      <app-cells><h2 class="title">Unallocated clients</h2></app-cells>
      <v-client-table
        :data="table_clients.items"
        :columns="table_clients.columns"
        :options="table_clients.options"
        class="table-default table-default--maxw"
      >
        <template #h__select>
          <label
            v-if="table_clients.items.length"
            class="checkbox checkbox--table"
          >
            <input
              v-model="checked_all"
              type="checkbox"
              name="checked_all"
            />
            <span class="checkbox__checkmark"></span>
          </label>
        </template>
        <template #h__full_name>
          <div class="table-default__left">Full name</div>
        </template>
        <template #h__group>
          <div class="table-default__left">Group</div>
        </template>
        <template #select="{ row }">
          <label class="checkbox  checkbox--table">
            <input
              v-model="checked"
              type="checkbox"
              :value="row"
            />
            <span class="checkbox__checkmark"></span>
          </label>
        </template>
        <template #full_name="{ row }">
          <div class="table-default__left table-default__left--photo">
            <span
              :class="`fflag ff-md fflag-${row.client.citizenship ? row.client.citizenship.code : 'empty'}`"
              v-tooltip="{ content: row.client.citizenship ? row.client.citizenship.name : 'Not provided', placement: 'top-start', offset: 10 }"
            ></span>
            <img v-if="row.client.gender?.code === 'male'" src="@/assets/img/male-icon.svg" alt="">
            <img v-if="row.client.gender?.code === 'female'" src="@/assets/img/female-icon.svg" alt="">
            <img v-if="!row.client.gender" src="@/assets/img/gender-plug-icon.svg" alt="">
            <router-link
              v-if="is_general_manager || is_sales_manager || is_sales_supervisor || is_operations_manager || is_operations_supervisor"
              :to="{ name: 'clients-detail', params: { id: row.client.id } }"
              class="table-default__link-border"
            >
              {{ row.client.full_name }}
            </router-link>
            <span v-else>{{ row.client.full_name }}</span>
            <span v-if="row.age">({{ row.age }} y.o.)</span>
          </div>
        </template>
        <template #group="{ row }">
          <template v-if="row.client.group">
            <router-link
              v-if="is_general_manager || is_sales_manager || is_sales_supervisor || is_operations_manager || is_operations_supervisor"
              :to="{ name: 'clients-groups-general', params: { id: row.client.group.id } }"
              class="table-default__link-border"
            >
              {{ row.client.group.name }}
            </router-link>
            <div v-else class="table-default__left">{{ row.client.group.name }}</div>
          </template>
          <div v-else class="table-default__left">-</div>
        </template>
        <template #manager="{ row }">
          <div class="table-default__controls">
            <div class="table-default__photo">
              <img
                :src="getUserAvatar(row.client.manager.crop.crop_url)" alt=""
                v-tooltip="{ content: row.client.manager.full_name, placement: 'top-start', offset: 10 }"
              >
            </div>
          </div>
        </template>
      </v-client-table>
    </template>
    <modal
      name="delete"
      :width="400"
      :height="'auto'"
      :scrollable="true"
      :adaptive="true"
      :clickToClose="false"
      class="modal-not-overflow"
      draggable=".popup__title"
      :reset="true"
    >
      <div class="popup">
        <button @click="$modal.hide('delete')" class="popup__close" type="button"></button>
        <div class="popup__title popup__title--flex">
          <img src="@/assets/img/warning-round-icon.svg" alt="">
          Delete event
        </div>
        <div class="popup__body">
          <div class="popup__subt">Are you sure you want to delete this event?</div>
          <app-cells position="center" :indent="false">
            <app-button @click.native="$modal.hide('delete')" theme="dark">Cancel</app-button>
            <app-button @click.native="onDeleteEvent" ref="deleteEvent">Yes</app-button>
          </app-cells>
        </div>
      </div>
    </modal>
    <modal
      name="event-modal"
      :width="400"
      :height="'auto'"
      :scrollable="true"
      :adaptive="true"
      :clickToClose="false"
      class="modal-not-overflow"
      draggable=".popup__title"
      :reset="true"
    >
      <div class="popup">
        <button @click="onHideEventModal" class="popup__close" type="button"></button>
        <div class="popup__title">{{ !event_to_update ? 'Assign new' : 'Updating' }} {{ groupDetail.route.accommodation_type?.code === 'huts' ? 'hut' : 'tent' }}</div>
        <div class="popup__body">
          <app-form-group label="Clients" required>
            <app-select
              v-model="form.clients"
              :options="clients_options"
              :selectable="onCalcPaxLimit"
              :clearable="false"
              :get-option-label="item => item.client.full_name"
              :display-field="option => option.client.full_name"
              multiple
              placeholder="Clients"
              :error="$v.form.clients.$error"
            />
            <template #error>
              <div v-if="$v.form.clients.$dirty && !$v.form.clients.required">Required field</div>
              <div v-if="$v.form.clients.$dirty && !$v.form.clients.maxLength">
                Number of clients must be less or equal to {{ form.additional_service ? form.additional_service.pax_limit : 2 }}
              </div>
            </template>
          </app-form-group>
          <app-form-group v-if="groupDetail.route.accommodation_type?.code === 'tents'" label="Additional service">
            <app-select
              @input="$v.form.$touch"
              v-model="form.additional_service"
              :options="service_options"
              placeholder="Additional service"
            />
          </app-form-group>
          <app-cells position="center" :indent="false">
            <app-button
              @click.native="onCheckForm"
              ref="createEvent"
              :disabled="$v.form.$error"
            >
              {{ !event_to_update ? 'Assign' : 'Update' }} {{ groupDetail.route.accommodation_type?.code === 'huts' ? 'hut' : 'tent' }}
            </app-button>
          </app-cells>
        </div>
      </div>
    </modal>
    <div class="flying-block" :class="{ 'flying-block--show': is_show_flying_block }">
      <div class="flying-block__text">Selected clients: <span>{{ checked.length }}</span></div>
      <app-button @click.native="onShowEventModal(null)">
        Assign {{ groupDetail.route.accommodation_type?.code === 'huts' ? 'hut' : 'tent' }}
      </app-button>
    </div>
  </div>
</template>

<script>
import {
  deleteClimbingGroupsTent,
  getClimbingAdditionalServiceDict,
  getClimbingGroupClientOptions,
  getClimbingGroupsTents,
  patchClimbingGroupsTent,
  postClimbingGroupsTent,
} from '@/http'
import { format, parse, parseISO } from 'date-fns'
import { maxLength, required } from 'vuelidate/lib/validators'

export default {
  name: 'ClimbingGroupsDetailTents',
  props: {
    groupDetail: {
      type: Object
    }
  },
  data() {
    return {
      table: {
        items: [],
        columns: ['count', 'clients', 'additional_service', 'created_by', 'updated_by'],
        options: {
          headings: {
            count: '#',
            clients: 'Clients',
            additional_service: 'Additional service',
            created_by: 'Created by',
            updated_by: 'Updated by',
            controls: '',
          },
          pagination: { show: false },
          sortable: [],
          perPage: 100,
          texts: {
            noResults: 'No matching entries',
          },
          rowClassCallback: () => 'table-default__row',
          resizableColumns: false
        },
      },
      table_clients: {
        items: [],
        columns: ['full_name', 'group', 'manager'],
        options: {
          headings: {
            select: '',
            full_name: 'Full name',
            group: 'Group',
            manager: 'Manager',
          },
          pagination: { show: false },
          sortable: [],
          perPage: 100,
          texts: {
            noResults: 'No matching entries',
          },
          rowClassCallback: () => 'table-default__row',
          resizableColumns: false
        },
      },
      event_to_delete: null,
      checked_all: false,
      checked: [],
      is_show_flying_block: false,
      form: {
        clients: [],
      },
      clients_options: [],
      event_to_update: null,
      service_options: [],
    }
  },
  validations() {
    const form = {
      clients: {
        required,
        maxLength: maxLength(this.maxLengthClients)
      },
    }
    return { form }
  },
  computed: {
    maxLengthClients() {
      if (this.form.additional_service) return this.form.additional_service.pax_limit
      if (this.groupDetail.route.accommodation_type?.code === 'huts') return 2
      return 3
    },
    is_general_sales() {
      return this.$store.state.userGroups.map(item => item.code).includes('general_manager') || this.$store.state.userGroups.map(item => item.code).includes('sales_manager')
    },
    is_general_manager() {
      return this.$store.state.userGroups.map(item => item.code).includes('general_manager')
    },
    is_sales_manager() {
      return this.$store.state.userGroups.map(item => item.code).includes('sales_manager')
    },
    is_sales_supervisor() {
      return this.$store.state.userGroups.map(item => item.code).includes('sales_supervisor')
    },
    is_operations_manager() {
      return this.$store.state.userGroups.map(item => item.code).includes('operations_manager')
    },
    is_operations_supervisor() {
      return this.$store.state.userGroups.map(item => item.code).includes('operations_supervisor')
    },
    show_select_col() {
      return this.is_general_sales ||
        this.$store.state.userGroups.map(item => item.code).includes('operations_supervisor') ||
        this.$store.state.userGroups.map(item => item.code).includes('general_manager') ||
        this.$store.state.userGroups.map(item => item.code).includes('sales_supervisor') ||
        this.$store.state.userGroups.map(item => item.code).includes('sales_manager') ||
        this.$store.state.userGroups.map(item => item.code).includes('climbing_supervisor')
    },
    show_controls() {
      return this.is_general_sales ||
        this.$store.state.userGroups.map(item => item.code).includes('climbing_manager') ||
        this.$store.state.userGroups.map(item => item.code).includes('climbing_supervisor') ||
        this.$store.state.userGroups.map(item => item.code).includes('sales_supervisor') ||
        this.$store.state.userGroups.map(item => item.code).includes('operations_supervisor')
    }
  },
  watch: {
    checked_all(value) {
      if (value) {
        this.table_clients.items.forEach(item => {
          if (!this.checked.includes(item.id)) this.checked.push(item)
        })
      } else {
        this.checked = []
      }
    },
    checked(value) {
      this.is_show_flying_block = value.length > 0
      if (!this.checked.length) this.checked_all = false
    },
  },
  created() {
    this.fetchItems()
    getClimbingAdditionalServiceDict({ tents: true, available_routes: this.groupDetail.route.id })
      .then(response => {
        this.service_options = response.data
      })
    if (this.groupDetail.route.accommodation_type?.code === 'huts') this.table.columns.splice(2, 1)
    if (this.show_controls) this.table.columns.push('controls')
    if (this.show_select_col) this.table_clients.columns.unshift('select')
  },
  methods: {
    onCheckForm() {
      this.$v.form.$touch()
      if (this.$v.form.$invalid) {
        this.$notify({
          type: 'info',
          title: 'Check that the form fields are filled in correctly',
        })
      } else {
        this.sendForm()
      }
    },
    sendForm() {
      this.$refs.createEvent.preload = true
      if (!this.event_to_update) {
        postClimbingGroupsTent(this.$route.params.id, this.normalizeForm())
          .then(() => {
            this.fetchItems()
            this.$emit('refreshTabCounts')
            this.$notify({
              type: 'success',
              title: 'Event created',
            })
            this.onHideEventModal()
            this.checked = []
          })
          .catch(() => {
            this.$refs.createEvent.preload = false
          })
      } else {
        patchClimbingGroupsTent(this.$route.params.id, this.event_to_update, this.normalizeForm())
          .then(() => {
            this.fetchItems()
            this.$emit('refreshTabCounts')
            this.$notify({
              type: 'success',
              title: 'Event updated',
            })
            this.onHideEventModal()
          })
          .catch(() => {
            this.$refs.createEvent.preload = false
          })
      }
    },
    normalizeForm() {
      const form = {...this.form}
      if (form.additional_service) form.additional_service = form.additional_service.code
      form.clients = form.clients.map(item => item.id)
      return form
    },
    fetchItems() {
      getClimbingGroupsTents(this.$route.params.id)
        .then(response => {
          this.table.items = response.data
        })
      getClimbingGroupClientOptions(this.$route.params.id, {tent_allocated: false})
        .then(response => {
          this.table_clients.items = response.data
        })
    },
    onShowEventModal(event) {
      if (!event) {
        this.event_to_update = null
        this.form.clients = this.checked
        this.clients_options = this.table_clients.items
      } else {
        this.event_to_update = event.id
        this.form = {
          additional_service: event.additional_service,
          clients: event.clients,
        }
        this.clients_options = [...this.table_clients.items, ...this.table.items.map(item => item.clients).flat()]
      }
      this.$modal.show('event-modal')
    },
    onHideEventModal() {
      this.$modal.hide('event-modal')
      this.form = {
        clients: [],
      }
      this.$v.form.$reset()
    },
    onShowDeleteModal(event_id) {
      this.event_to_delete = event_id
      this.$modal.show('delete')
    },
    onDeleteEvent() {
      this.$refs.deleteEvent.preload = true
      deleteClimbingGroupsTent(this.$route.params.id, this.event_to_delete)
        .then(() => {
          this.fetchItems()
          this.$emit('refreshTabCounts')
          this.$modal.hide('delete')
          this.$notify({
            type: 'success',
            title: 'Tent deleted',
          })
        })
        .catch(() => {
          this.$refs.deleteEvent.preload = false
        })
    },
    getUserAvatar(crop_url) {
      if (crop_url) return crop_url
      return require('@/assets/img/temp/avatar-slug.jpg')
    },
    dateFormat(date) {
      return format(parse(date, 'yyyy-MM-dd', new Date()), 'dd MMM yyyy')
    },
    dateTimeFormat(date) {
      return date ? format(parseISO(date), 'dd MMM yyyy HH:mm') : '-'
    },
    tooltipContent(data) {
      return `${data.updated_by.full_name}<br>${this.dateTimeFormat(data.updated_at)}`
    },
    onCalcPaxLimit() {
      if (this.form.additional_service) return this.form.clients.length < this.form.additional_service.pax_limit
      return this.form.clients.length < 2
    },
  }
}
</script>
